import { render, staticRenderFns } from "./web-switch.vue?vue&type=template&id=47d52ca4&scoped=true&"
import script from "./web-switch.vue?vue&type=script&lang=js&"
export * from "./web-switch.vue?vue&type=script&lang=js&"
import style0 from "./web-switch.vue?vue&type=style&index=0&id=47d52ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d52ca4",
  null
  
)

export default component.exports